import toArray from '@/helpers/toArray';

export default (element) => {
  const checkboxes = toArray(element.querySelectorAll('input[type="checkbox"]:checked'));
  // const radios = toArray(element.querySelectorAll('input[type="radio"]'));
  const textInputs = toArray(element.querySelectorAll('input[type="text"], input[type="number"], input[type="hidden"]'));

  const selectedItems = {};

  textInputs.forEach((textInput) => {
    if (textInput.getAttribute('data-default')) {
      const defaultValue = textInput.getAttribute('data-default');

      if (defaultValue === textInput.value) {
        return;
      }
    }

    selectedItems[textInput.name] = textInput.value;
  });

  checkboxes.forEach((checkbox) => {
    selectedItems[checkbox.name] = checkbox.value;
  });

  return selectedItems;
};
